import { render, staticRenderFns } from "./InvoiceLogMessageViewer.yaml?vue&type=template&id=56fbc0fa&component"
import script from "./InvoiceLogMessageViewer.yaml?vue&type=script&lang=ts&component"
export * from "./InvoiceLogMessageViewer.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports